import _ from 'lodash';
import {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import API from '../../../app/api';
import {BMDestination, BMProwizorkaRefreshData, prepareDataBM} from '../../../store/reducers/bedManagement';
import {setSnackbar} from '../../../store/reducers/globals';

const useRequests = (selectedWard, allReqs) => {
    const controller = new AbortController();
    const dispatch = useDispatch();

    const shouldUpdate = useSelector(BMProwizorkaRefreshData);
    const isDestination = useSelector(BMDestination);

    const [requests, setRequests]   = useState([]);
    const [allRequests, setAllRequests] = useState([]);
    const [requestsLoading, setRequestsLoading]   = useState(false);

    useEffect(async () => {
        if (!!selectedWard || !!shouldUpdate) {
            setRequestsLoading(true);
            let data = [];
            const obj = {
                wardIds: [selectedWard],
                destination: isDestination,
            };

            const obj2 = {
                wardIds: [selectedWard],
                destination: !isDestination,
            };

            if (!selectedWard) {
                delete obj.wardIds;
            }

            API.getPatientsWithBedRequest(obj)
                .then(res => {
                    dispatch(prepareDataBM(res?.__data, true))
                        .then(local => {
                            setRequests(local);

                            if (allReqs) {
                                API.getPatientsWithBedRequest(obj2)
                                    .then(res => {
                                        dispatch(prepareDataBM(res?.__data, true))
                                            .then(localAll => {
                                                setAllRequests([...local, ...localAll]);
                                            })
                                    })
                                    .catch(err => {
                                        console.error(err);
                                        dispatch(setSnackbar({type: 'error', message: 'Cannot load bed requests.'}));
                                    });
                            }
                        });
                })
                .catch(err => {
                    console.error(err);
                    dispatch(setSnackbar({type: 'error', message: 'Cannot load bed requests.'}));
                });


            return () => {
                setRequestsLoading(false);
                controller.abort();
            };
        }
    }, [selectedWard, shouldUpdate, isDestination])
    
    return [requests, requestsLoading, allRequests];
}

export default useRequests;